import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { FormControlName, FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { IUser, IChangePassword } from "./user";
import { GenericValidator } from "../shared/generic-validator";
import { UserService } from "./user.service";
import { Observable } from "rxjs/Observable";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
    templateUrl:"./mydetails.component.html"
})
export class MydetailsComponent implements OnInit, AfterViewInit{
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    public pageTitle: string = 'My Details';
    userForm: FormGroup;
    user: IUser;
    changePasswordForm: FormGroup;
    changePassword: IChangePassword;
    // Use with the generic validation message class
    displayMessage: { [key: string]: string } = {};
    displayMessageChangePassword: { [key: string]: string } = {};
    private validationMessages: { [key: string]: { [key: string]: string } };
    private validationMessagesChangePassword: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    private genericValidatorChangePassword: GenericValidator;
    public showProfileUpdate: boolean = true;
    
    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        public userService: UserService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;

        // Defines all of the validation messages for the form.
        // These could instead be retrieved from a file or database.
        this.validationMessages = {
            firstName: {
                required: 'firstName name is required.'
            },
            lastName: {
                required: 'lastName name is required.'
            },
            email: {
                required: 'email name is required.',
                pattern: 'invalid email address.'
            }
        };

        this.validationMessagesChangePassword = {
            oldPassword: {
                required: 'Old Password is required.'
            },
            newPassword: {
                required: 'New Password is required.'
            },
            confirmPassword: {
                required: 'Confirm Password is required.'
            }
        };

        // Define an instance of the validator for use with this form, 
        // passing in this form's set of validation messages.
        this.genericValidator = new GenericValidator(this.validationMessages);
        this.genericValidatorChangePassword = new GenericValidator(this.validationMessagesChangePassword);
        this.loaderService.display(true);
    }
   
    ngOnInit(): void {
        this.headerAndNavigationService.showhideNav(false, true);
        this.userForm = this.fb.group({            
            title: '',
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+')]],
            telephone: '',
            mobile: '',
            fax: '',
            jobTitle: '',
            address1: '',
            address2: '',
            town: '',
            county: '',
            postcode: ''
        });
        this.getUser();

        this.changePasswordForm = this.fb.group({            
            id:'',
            oldPassword: ['', Validators.required],
            newPassword: ['', Validators.required],
            //confirmPassword: ['', [Validators.required]]
        });
    }

    ngAfterViewInit(): void {
        // Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

        // Merge the blur event observable with the valueChanges observable
        Observable.merge(this.userForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.userForm);
        });

        // Merge the blur event observable with the valueChanges observable
        Observable.merge(this.changePasswordForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
            this.displayMessageChangePassword = this.genericValidatorChangePassword.processMessages(this.changePasswordForm);
        });
    }

    checkStandardUserEnableUpdateUserProfile() {
      this.authService.checkStandardUserEnableUpdateUserProfile()
        .subscribe(
        (data: any) => {
          this.showProfileUpdate = (data == "true");
        },
        (error: any) => {
          this.userService.showError("Standard user profile access flag checking problem", <any>error, true);
        }
        );
    }

    getUser(): void {
        let token = this.authService.getToken();
        
        this.userService.getUser(token.userId)
        .subscribe(
            (user: IUser) => {
                this.loaderService.display(false);
                this.onUserRetrieved(user);
                this.checkStandardUserEnableUpdateUserProfile();
            },
            (error: any) => {
                this.loaderService.display(false);
                this.userService.showError("User retrieval problem", <any>error);
                this.headerAndNavigationService.RedirectToLogin();
            }
        );
    }

    //checkStandardUserEnableUpdateUserProfile() {
    //  this.authService.checkStandardUserEnableUpdateUserProfile()
    //    .subscribe(
    //    (data: any) => {
    //      this.showChangeForceChangePassword = (data == "true");
    //      this.showInitialPopUps();
    //    },
    //    (error: any) => {
    //      this.userService.showError("Standard user password flag checking problem", <any>error, true);
    //    }
    //    );
    //}

    onUserRetrieved(user: IUser): void {
        if (this.userForm) {
            this.reSetForm();
        }
        this.user = user;

        // Update the data on the form
        this.userForm.patchValue({            
            title: this.user.title,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            telephone: this.user.telephone,
            mobile: this.user.mobile,
            fax: this.user.fax,
            jobTitle: this.user.jobTitle,
            address1: this.user.address1,
            address2: this.user.address2,
            town: this.user.town,
            county: this.user.county,
            postcode: this.user.postcode
        });
    }
    
    saveUser(): void {
        this.loaderService.display(true);
        if (this.userForm.dirty && this.userForm.valid) {
            // Copy the form values over the product object values
            let p = Object.assign({}, this.user, this.userForm.value);            
            this.userService.saveUser(p)
                .subscribe(
                    () => {                        
                      this.loaderService.display(false);
                      this.userService.showSuccess("User Info", "User info updated successfully.");
                    },
                    (error: any) => {                        
                      this.loaderService.display(false);
                      this.userService.showError("User create / edit problem",<any>error);
                    }
                );
        } else if (!this.userForm.dirty) {
          this.loaderService.display(false);
          this.userService.showSuccess("User Info", "User info updated successfully.");
        }
    }

    reSetForm()
    {
        this.userForm.reset();
    }

    reSetChangePasswordForm() {
        this.changePasswordForm.reset();
    }

    changePasswordClick(): void {
        if (this.changePasswordForm) {
            this.reSetChangePasswordForm();
        }
        $('#resetpassModal').modal('show');        
    }

    changePasswordSubmit(): void {
        if (this.changePasswordForm.valid) {
            // Copy the form values over the product object values
            this.changePasswordForm.patchValue({
                id: this.user.id,            
            });
            let p = Object.assign({}, this.changePassword, this.changePasswordForm.value);            
            this.loaderService.display(false);
            this.userService.updateUserPassword(p)
                .subscribe(
                () => {
                    $('#resetpassModal').modal('hide');
                    this.loaderService.display(false);
                    this.reSetChangePasswordForm();
                    this.userService.showSuccess("Change Password", "Password changed successfully.");                    
                },
                (error: any) => {                    
                    this.loaderService.display(false);
                    this.userService.showError("Change Password", <any>error, true);
                }
                );
        } else if (!this.changePasswordForm.dirty) {
            this.reSetChangePasswordForm();
            $('#resetpassModal').modal('hide');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/users/mydetails.component.ts